<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-select
          v-model="workType"
          :items="workList"
          label="檢查Excel"
          :disabled="isAllTextFieldDisable"
          item-text="Name"
          item-value="Type"
        >
        </v-select>
      </v-col>
      <v-col>
        <input
          type="file"
          ref="file"
          style="display: none"
          v-if="resetUploadFile"
          @change="uploadFile"
        />
        <v-btn
          color="primary"
          :disabled="isAllTextFieldDisable || workType === 0"
          :loading="isLoading"
          @click="$refs.file.click()"
        >
          上傳
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="isShowFailDialog" max-width="800" persistent>
      <v-card color="error">
        <v-card-title class="text-h3 white--text">Error Message</v-card-title>
        <v-card-text
          class="white--text text-h5 mt-5"
          v-for="message of failDialogMessageList"
          :key="message"
        >
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" text @click="closeDialog">
            {{ $t('common_close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isShowSuccessDialog" max-width="500" persistent>
      <v-card color="success">
        <v-card-title class="text-h3 white--text">Success Message</v-card-title>
        <v-card-text class="white--text text-h5 mt-5">
          恭喜沒有任何錯誤，可以給RD匯Excel囉!!
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" text @click="isShowSuccessDialog = false">
            {{ $t('common_close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { HttpCheckExcel } from '@/js/http-Manager'
export default {
  name: 'CheckExcel',

  data: () => ({
    isAllTextFieldDisable: false,
    workType: 0,
    isLoading: false,
    isShowFailDialog: false,
    failDialogMessageList: [],
    resetUploadFile: true,
    isShowSuccessDialog: false
  }),
  computed: {
    workList () {
      return [
        { Type: 1, Name: 'Bom Excel' },
        { Type: 2, Name: '新品品號 Excel' },
        { Type: 3, Name: '良品品號 Excel' },
        { Type: 4, Name: '資產資料類別 Excel' },
        { Type: 5, Name: '客戶基本資料 Excel' },
        { Type: 6, Name: '資產資料單頭 Excel' },
        { Type: 7, Name: '資產資料單身 Excel' },
        { Type: 8, Name: '廠商 Excel' },
        { Type: 9, Name: '月租BOM Excel' },
        { Type: 10, Name: '月租單頭(客戶月租檔) Excel' },
        { Type: 11, Name: '月租單身(合約活動紀錄) Excel' },
        { Type: 12, Name: '履歷卡 Excel' },
        { Type: 13, Name: '安裝位置 Excel' },
        { Type: 14, Name: '天心新品 Excel' },
        { Type: 15, Name: '天心良品 Excel' }
      ]
    }
  },
  methods: {
    async uploadFile (event) {
      if (event.target.files.length > 0) {
        this.resetUploadFile = false
        this.isLoading = true
        this.isAllTextFieldDisable = true
        let excelFile = event.target.files[0]
        let formData = new FormData()
        formData.append('File', excelFile)
        let response
        if (this.workType === 1) {
          response = await HttpCheckExcel.BomExcel(formData)
        } else if (this.workType === 2) {
          response = await HttpCheckExcel.NewItemExcel(formData)
        } else if (this.workType === 3) {
          response = await HttpCheckExcel.OldItemExcel(formData)
        } else if (this.workType === 4) {
          response = await HttpCheckExcel.AstTypeExcel(formData)
        } else if (this.workType === 5) {
          response = await HttpCheckExcel.CustomerExcel(formData)
        } else if (this.workType === 6) {
          response = await HttpCheckExcel.AstmbExcel(formData)
        } else if (this.workType === 7) {
          response = await HttpCheckExcel.AstmcExcel(formData)
        } else if (this.workType === 8) {
          response = await HttpCheckExcel.SupplierExcel(formData)
        } else if (this.workType === 9) {
          response = await HttpCheckExcel.MonthBomExcel(formData)
        } else if (this.workType === 10) {
          response = await HttpCheckExcel.MonthHeadExcel(formData)
        } else if (this.workType === 11) {
          response = await HttpCheckExcel.MonthBodyExcel(formData)
        } else if (this.workType === 12) {
          response = await HttpCheckExcel.ResumeExcel(formData)
        } else if (this.workType === 13) {
          response = await HttpCheckExcel.InstallPositionExcel(formData)
        } else if (this.workType === 14) {
          response = await HttpCheckExcel.SunlikeNewItemExcel(formData)
        } else if (this.workType === 15) {
          response = await HttpCheckExcel.SunlikeOldItemExcel(formData)
        }
        if (response.data.Data.length > 0) {
          this.openDialog(response.data.Data)
        } else {
          this.isShowSuccessDialog = true
        }
        this.isLoading = false
        this.isAllTextFieldDisable = false
        this.resetUploadFile = true
      }
    },
    closeDialog () {
      this.isShowFailDialog = false
    },
    openDialog (messageList) {
      this.failDialogMessageList = messageList
      this.isShowFailDialog = true
    }
  }
}
</script>
